export default __webpack_public_path__ + "static/logo-fixed-50c2b029579e1e5421642e6bee62f46a.png";